import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {Stack} from "@mui/material";
import {styled} from "@mui/material/styles";

import ListingCheckbox from "components/Product/Table/ListingCheckbox";
import ListingCtrBadge from "components/Product/Table/ListingCtrBadge";
import ListingProductImageCell from "components/Product/Table/ListingProductImageCell";
import {black500, greyishBlue500, greyishBlue600} from "assets/jss/main";

ProductCell.propTypes = {
    name: PropTypes.string,
    retailerName: PropTypes.string,
    brandName: PropTypes.string,
    reference: PropTypes.string,
    pictureUrl: PropTypes.string,
    groupedSearchImpression: PropTypes.number,
    ctr: PropTypes.number,
    selected: PropTypes.bool,
    selectable: PropTypes.bool,
    onSelect: PropTypes.func,
};

const Info = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: 0,
    flex: 1,
});

const Name = styled('span')({
    color: black500,
    fontSize: '14px',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});

const Line = styled('span')({
    color: black500,
    fontSize: '14px',
});

const Reference = styled('span')({
    fontSize: '14px',
    color: greyishBlue500,
    '& > span': {
        color: greyishBlue600,
    },
});

function ProductCell({name, retailerName, brandName, reference, pictureUrl, groupedSearchImpression, ctr, selected = false, selectable = false, onSelect}) {
    return (
        <Stack direction="row" alignItems="flex-start" gap="16px" sx={{width: '302px'}}>
            <Stack direction="row" alignItems="center" gap="8px">
                <ListingCheckbox checked={selected} disabled={!selectable} onClick={onSelect}/>
                <ListingProductImageCell src={pictureUrl} groupedSearchImpression={groupedSearchImpression}/>
            </Stack>
            <Info>
                <ListingCtrBadge ctr={ctr}/>
                <Name title={name}>{name}</Name>
                <Stack gap="4px">
                    {retailerName && <Line>{retailerName}</Line>}
                    {brandName && <Line>{brandName}</Line>}
                </Stack>
                {reference && (
                    <Reference>
                        <FormattedMessage id="enrichment.product.reference"/> <span>:</span> {reference}
                    </Reference>
                )}
            </Info>
        </Stack>
    );
}

export default ProductCell;
